// Delegated handler survives section re-renders
(function () {
  function $ (sel, root=document) { return root.querySelector(sel); }

  async function fetchHTML(url) {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
    return res.text();
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.load-more_btn');
    if (!btn) return;

    const grid   = $('#ProductGridContainer');
    const nextEl = $('#paginateNext');
    const spin   = $('.load-more_spinner');

    if (!grid || !nextEl || !spin) return;

    const nextUrl = nextEl.dataset.nextUrl || '';
    if (!nextUrl) return;

    btn.style.display = 'none';
    spin.style.display = 'block';

    try {
      const html = await fetchHTML(nextUrl);
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = $('#ProductGridContainer', doc);
      if (!newGrid) throw new Error('Next page grid not found');

      // Append new items
      Array.from(newGrid.children).forEach(el => grid.appendChild(el));

      // Update next URL from fetched page
      const docNext = $('#paginateNext', doc);
      const newNext = docNext ? (docNext.dataset.nextUrl || '') : '';
      nextEl.dataset.nextUrl = newNext;

      // 🔔 Tell others we added items (Trustpilot reload will listen)
      document.dispatchEvent(new CustomEvent('product-grid:appended', {
        detail: { root: grid }
      }));

      if (newNext) btn.style.display = 'flex';
    } catch (err) {
      console.error(err);
      btn.style.display = 'flex';
    } finally {
      spin.style.display = 'none';
      if (!nextEl.dataset.nextUrl) btn.style.display = 'none';
    }
  });

  // Hide button on first load if no next page
  document.addEventListener('DOMContentLoaded', () => {
    const btn = document.querySelector('.load-more_btn');
    const nextEl = document.getElementById('paginateNext');
    if (btn && nextEl && !nextEl.dataset.nextUrl) btn.style.display = 'none';
  });
})();
